<template>
  <div>
    <!-- 配置表格 -->
    <div class="configTable">
      <div class="configTh">
        <span
          :style="{ flex: item.flex }"
          v-for="(item, index) in configHead"
          :key="'confighead' + index"
          >{{ item.name }}</span
        >
      </div>
      <template v-if="configList.length > 0">
        <div
          class="configItem"
          v-for="(item, index) in configList"
          :key="'confingItem' + index"
        >
          <div class="edit" @click="aaa(item)">
            <span class="activityName">{{
              item.name || item.activityName
            }}</span>
            <span class="state" v-if="item.status == 2">进行中</span>
            <span class="state" v-else-if="item.status == 1">未开始</span>
            <span class="state" v-else-if="item.status == 3">已结束</span>
            <div class="icon">
              <img @click="selectPicture(item)" :src="item.imageUrl" />
            </div>
            <div class="sort">
              <i
                class="iconfont"
                :class="{ disabled: index == 0 }"
                @click="movePower({ id: item.id, type: 'moveUp' })"
                >&#xe691;</i
              >
              <i
                class="iconfont"
                :class="{ disabled: index == configList.length - 1 }"
                @click="movePower({ id: item.id, type: 'moveDown' })"
                >&#xe690;</i
              >
            </div>
            <div class="eye">
              <i
                class="iconfont"
                :class="{ visible: !item.visibility }"
                @click="handleVisibility(item.id)"
                >&#xe695;</i
              >
            </div>
          </div>
          <div class="link" v-if="notDesc">
            <el-input v-model="item.desc" class="linkIpt"></el-input>
            <i
              v-if="isShow"
              class="jumpLink iconfont"
              @click="checkCurLinkItem(item), (linkAdminVisible = true)"
              >&#xe693;</i
            >
          </div>
        </div>
      </template>
    </div>

    <!-- 图片管理 -->
    <PhotoGallery
      :isShow="photoGalleryVisible"
      @close="photoGalleryChange"
    ></PhotoGallery>
    <!-- 链接管理 -->
    <LInkAdmin :isShow="linkAdminVisible" @close="linkAdminChange"></LInkAdmin>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import PhotoGallery from "@/components/PhotoGallery";
import LInkAdmin from "@/components/LInkAdmin";
import selectPictureMiXin from "@/mixin/selectPictureMiXin";
export default {
  mounted() {
    this.configList.forEach((item, index) => {
      if (item.status == 3) {
        this.configList.splice(index, 1);
      }
    });
  },
  props: {
    configHead: {
      type: Array,
      default: () => {
        return [];
      },
    },
    configList: {
      type: Array,
      required: true,
    },
    notDesc: {
      type: Boolean,
      default: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PhotoGallery,
    LInkAdmin,
  },
  data() {
    return {
      photoGalleryVisible: false,
      curSelectItem: null,
      linkAdminVisible: false,
      configListlist: [],
    };
  },
  mixins: [selectPictureMiXin],
  methods: {
    ...mapMutations([
      "movePower",
      "handleVisibility",
      "replaceIcon",
      "editItemLink",
      "checkCurLinkItem",
    ]),

    aaa(item) {
      console.log(item);
    },
    // 选择链接后返回
    linkAdminChange(data) {
      this.linkAdminVisible = false;
      if (data) {
        //有数据返回
        this.editItemLink(data);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.configTable {
  margin-top: 20px;
  overflow: auto;
  height: 600px;
  &::-webkit-scrollbar {
    display: none;
  }
  .configTh {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 30px;
    height: 50px;
    background-color: #fafafa;
    span {
      color: #333;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .configItem {
    box-sizing: border-box;
    padding: 16px 30px 20px;
    border-bottom: 1px solid #f3f3f3;
    &:last-child {
      border: none;
    }
    .edit {
      display: flex;
      align-items: center;
      .activityName {
        flex: 2;
        color: #333333;
        font-size: 14px;
        font-weight: 400;
      }
      .state {
        flex: 2;
        color: #fe4d45;
        font-size: 14px;
        font-weight: 400;
      }
      .icon {
        width: 65px;
        height: 40px;
        img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
        }
      }
      .sort {
        flex: 1;
        i {
          cursor: pointer;
          &.disabled {
            color: #dddddd;
            cursor: no-drop;
          }
        }
      }
      .eye {
        flex: 1;
        i {
          color: #666;
          cursor: pointer;
          transition: all 0.3s;
        }
        .visible {
          color: #ccc;
        }
      }
    }
    .link {
      position: relative;
      margin-top: 16px;
      .linkIpt {
        height: 32px;
        /deep/ .el-input__inner {
          height: 32px;
        }
      }
      .jumpLink {
        position: absolute;
        right: 1px;
        top: 1px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: #eeeeee;
        cursor: pointer;
      }
    }
  }
  .handle {
    box-sizing: border-box;
    padding-left: 30px;
    margin-top: 16px;
    color: #999;
    font-size: 13px;
    font-weight: 400;
    .add {
      display: inline-block;
      margin-right: 12px;
      cursor: pointer;
      color: #7f85e9;
    }
  }
}
</style>
